import HolidaysTable from './HolidaysTable';

export default HolidaysTable;
